import { Box, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

const SlideSection = ({ children, size, borderRight }) => {
  const theme = useTheme();

  return (
    <Grid
      container
      direction="column"
      size={size || 12}
      columnSpacing={2}
      rowSpacing={1}
      justifyContent={"start"}
      sx={{
        position: "relative",
      }}
    >
      {children}
      {borderRight && (
        <Box
          sx={{
            position: "absolute",
            top: "0",
            right: theme.spacing(-1), // Décalage de la bordure à droite
            width: "1px",
            height: "100%",
            backgroundColor: "#ccc", // Bordure noire
          }}
        />
      )}
    </Grid>
  );
};

export default SlideSection;
